module.exports = __webpack_public_path__ + "static/media/cardcloseicon.7a82dad5.svg";